// 통합 파트너: 기방에서만 기존 규정(4226)과 가상계좌 안내(4293)를 숨긴다.
export function filterGibangNotices (list) {
  if (window.location.hostname !== 'a39.gibang-111.com') return list
  return Array.isArray(list) ? list.filter(item => !['4226', '4293'].includes(String(item.boardIdx))) : list
}
